import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DialogConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      text: string;
      actionLabels?: {
        cancel?: string;
        proceed?: string;
      };
      [key: string]: any;
    }
  ) {}

  confirm(e: boolean) {
    this.dialogRef.close(e);
  }
}
